module.exports = __webpack_public_path__ + "mainassets/img/plus.a93808e1.svg";